import { defineStore, acceptHMRUpdate } from 'pinia';
import { EXPANDED_NAV_LS_KEY } from '@/constants/nav';
import { EventBus } from '@utils/event-bus.js';

interface LeftNavState {
    expanded: boolean;
    isTopBannerDismissed: boolean;
    isBlurred: boolean;
    topBannerHeight: number;
}

export function getInitialState (): LeftNavState {
    return {
        expanded: true,
        isTopBannerDismissed: false,
        isBlurred: false,
        topBannerHeight: 0,
    };
}

export const useLeftNavStore = defineStore('leftNav', {
    state: getInitialState,
    actions: {
        expandCollapseNav ({ expanded }: { expanded: boolean }) {
            this.expanded = expanded;
            globalThis.localStorage.setItem(EXPANDED_NAV_LS_KEY, String(expanded));
            EventBus.$emit('sideNavExpandedStateChanged');
        },
        setExpanded ({ expanded }: { expanded: boolean }) {
            this.expanded = expanded;
        },
        setTopBannerDismissed ({ isTopBannerDismissed }: { isTopBannerDismissed: boolean }) {
            this.isTopBannerDismissed = isTopBannerDismissed;
        },
        setBlurred ({ isBlurred }: { isBlurred: boolean }) {
            this.isBlurred = isBlurred;
        },
        setTopBannerHeight ({ topBannerHeight }: { topBannerHeight: number }) {
            this.topBannerHeight = topBannerHeight;
        },
    },
});

if (module.hot) {
    module.hot.accept(acceptHMRUpdate(useLeftNavStore, module.hot));
}
